import React from 'react';
import Article from '../../../src/resources/Article.jsx';

export function Page() {
  return <Article />;
}
